const l = {
  name: "KeyGroupRefresh",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11,0C4.9,0,0,4.9,0,11c0,4.7,2.9,8.7,7,10.2v5.2L8.6,28l-2,2l2,2L7,33.6v2.9l4,3.5l4-3.5V21.2
			c0.1-0.1,0.3-0.1,0.4-0.2l3.7,3.7h2.2v2.8h2.8v2.2l2,2l5.3-0.3l0.3-5.3L21.1,15.4c0.1-0.1,0.1-0.3,0.2-0.4h5.2l1.6-1.6l2,2l2-2
			l1.6,1.6h2.9l3.5-4l-3.5-4H21.2C19.6,2.9,15.7,0,11,0z M22,11c0-0.7-0.1-1.4-0.2-2h13.7l1.8,2l-1.8,2h-1.1L32,10.6l-2,2l-2-2
			L25.6,13h-3.8C21.9,12.4,22,11.7,22,11z M18,5.3C17.4,5.1,16.7,5,16,5c-3.3,0-6,2.7-6,6v1.6l-2.3-2.3l-1.4,1.4l4.7,4.7l4.7-4.7
			l-1.4-1.4L12,12.6V11c0-2.2,1.8-4,4-4s4,1.8,4,4c0,4-2.6,7.4-6.3,8.6L13,19.8v15.7l-2,1.8l-2-1.8v-1.1l2.4-2.4l-2-2l2-2L9,25.6
			v-5.8l-0.7-0.2C4.6,18.4,2,15,2,11c0-5,4-9,9-9C13.8,2,16.3,3.3,18,5.3z M20.1,17.2l9.7,9.7l-0.2,2.7l-2.7,0.2L26.1,29v-3.4h-2.8
			v-2.8h-3.4l-2.7-2.7C18.3,19.3,19.3,18.3,20.1,17.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as KeyGroupRefresh
};
